import { render } from "./create-store.vue?vue&type=template&id=bdef2d24&scoped=true"
import script from "./create-store.vue?vue&type=script&lang=js"
export * from "./create-store.vue?vue&type=script&lang=js"

import "./create-store.vue?vue&type=style&index=0&id=bdef2d24&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdef2d24"]])

export default __exports__